import yujinGocart180 from '../../../../assets/images/learn/yujin-gocart180.png';
import twinnyNargo100 from '../../../../assets/images/learn/twinny-nargo100.png';
import { cEl } from '../../../../util';

function HeavyDeliveryRobot() {
    const page = cEl('div');
    page.classList.add('learn-page');
    page.innerHTML = `
    <div class="gray-box">
        <h2>고중량 이송 로봇</h2>
        <div class="img-container">
            <div class="img-wrapper border-radius">
                <img src="${yujinGocart180}" alt="유진로봇 Gocart180">
                <span>유진로봇 Gocart180</span>
            </div>
            <div class="img-wrapper border-radius">
                <img src="${twinnyNargo100}" alt="트위니 나르고 100">
                <span>트위니 나르고 100</span>
            </div>
        </div>
        <div class="description-container">
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">사용처</div>
                <ul class="description-list">
                    <li>50kg 이상의 무게나 부피가 큰 물품 배송</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">장점</div>
                <ul class="description-list">
                    <li>환경과 상황에 따라 형태 변형 가능</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">주의점</div>
                <ul class="description-list">
                    <li>수직 이동 연동 제약</li>
                    <li>로봇마다 최대 중량 확인 필요</li>
                    <li>거대한 크기 확인 필요</li>
                </ul>
            </div>
        </div>
    </div>`;

    return page;
}

export default HeavyDeliveryRobot;
